/**
 * Sizing Chart Modal Handler
 * File: sizing_chart.js.liquid
 */

(function() {
  'use strict';

  class SizingChartModal {
    constructor() {
      this.modals = new Map();
      this.initialized = false;
      this.init();
    }

    init() {
      if (this.initialized) return;
      
      // Initialize when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initializeAll());
      } else {
        this.initializeAll();
      }

      // Re-initialize on product changes (for AJAX themes)
      document.addEventListener('product:changed', () => this.initializeAll());
      
      // Global ESC key handler
      document.addEventListener('keydown', (e) => this.handleEscKey(e));
      
      this.initialized = true;
      console.log('SizingChartModal system initialized');
    }

    initializeAll() {
      // Find all sizing chart triggers
      const triggers = document.querySelectorAll('[data-sizing-chart-trigger]');
      console.log('Found', triggers.length, 'sizing chart triggers');
      
      triggers.forEach(trigger => this.initializeTrigger(trigger));
    }

    initializeTrigger(trigger) {
      const blockId = trigger.dataset.blockId;
      
      if (!blockId) {
        console.warn('Sizing chart trigger missing block ID:', trigger);
        return;
      }

      // Skip if already initialized
      if (this.modals.has(blockId)) {
        console.log('Block already initialized:', blockId);
        return;
      }

      const config = this.getConfigFromTrigger(trigger);
      if (!config.image) {
        console.log('No sizing chart image found for block:', blockId);
        return;
      }

      // Create and append modal to body
      const modal = this.createModal(blockId, config);
      document.body.appendChild(modal);

      // Store modal reference
      this.modals.set(blockId, modal);

      // Bind events
      this.bindEvents(trigger, modal, blockId);

      console.log('Sizing chart initialized for block:', blockId);
    }

    getConfigFromTrigger(trigger) {
      console.log('Getting config from trigger:', trigger.dataset);
      return {
        image: trigger.dataset.image,
        imageAlt: trigger.dataset.imageAlt || 'Sizing Chart',
        title: trigger.dataset.title || 'Sizing Chart',
        description: trigger.dataset.description || ''
      };
    }

    createModal(blockId, config) {
      const modal = document.createElement('div');
      modal.id = `sizing-chart-modal-${blockId}`;
      modal.className = 'sizing-chart-modal';
      modal.style.display = 'none';

      const descriptionHtml = config.description ? 
        `<div class="sizing-chart-description">${this.escapeHtml(config.description)}</div>` : '';

      modal.innerHTML = `
        <div class="sizing-chart-modal-overlay" data-sizing-chart-close></div>
        <div class="sizing-chart-modal-content">
          <div class="sizing-chart-modal-header">
            <h3>${this.escapeHtml(config.title)}</h3>
            <button class="sizing-chart-modal-close" data-sizing-chart-close type="button">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="sizing-chart-modal-body">
            <img src="${this.escapeHtml(config.image)}" alt="${this.escapeHtml(config.imageAlt)}" class="sizing-chart-modal-image" />
            ${descriptionHtml}
          </div>
        </div>
      `;

      return modal;
    }

    bindEvents(trigger, modal, blockId) {
      // Open modal
      trigger.addEventListener('click', (e) => this.openModal(e, modal, blockId));

      // Close modal events
      const closeButtons = modal.querySelectorAll('[data-sizing-chart-close]');
      closeButtons.forEach(button => {
        button.addEventListener('click', () => this.closeModal(modal, blockId));
      });
    }

    openModal(e, modal, blockId) {
      e.preventDefault();
      e.stopPropagation();
      
      // Close any other open modals first
      this.closeAllModals();
      
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      console.log('Modal opened for block:', blockId);
    }

    closeModal(modal, blockId) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      
      console.log('Modal closed for block:', blockId);
    }

    closeAllModals() {
      this.modals.forEach((modal, blockId) => {
        if (modal.style.display === 'flex') {
          this.closeModal(modal, blockId);
        }
      });
    }

    handleEscKey(e) {
      if (e.key === 'Escape') {
        this.closeAllModals();
      }
    }

    escapeHtml(text) {
      if (!text) return '';
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Public method to manually initialize a specific block
    initializeBlock(blockId) {
      const trigger = document.querySelector(`[data-sizing-chart-trigger][data-block-id="${blockId}"]`);
      if (trigger) {
        this.initializeTrigger(trigger);
      }
    }

    // Public method to destroy a specific block
    destroyBlock(blockId) {
      const modal = this.modals.get(blockId);
      if (modal) {
        modal.remove();
        this.modals.delete(blockId);
        console.log('Destroyed modal for block:', blockId);
      }
    }

    // Public method to destroy all modals
    destroy() {
      this.modals.forEach(modal => modal.remove());
      this.modals.clear();
      this.initialized = false;
      console.log('All sizing chart modals destroyed');
    }
  }

  // Initialize the sizing chart system
  window.SizingChartModal = SizingChartModal;

  // Create global instance
  if (!window.sizingChartInstance) {
    window.sizingChartInstance = new SizingChartModal();
  }

})();